// @mui
import { Box } from '@mui/material';

// ----------------------------------------------------------------------

export default function IllustrationLogin({ ...other }) {
  return (
    <Box {...other}>
      <svg
        id="Layer_1"
        data-name="Layer 1"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 890.143 862.058"
        width="100%"
        height="100%"
      >
        <g>
          <ellipse cx="638.143" cy="838.805" rx="252" ry="23.253" fill="#fff" />
          <ellipse cx="638.143" cy="838.805" rx="252" ry="23.253" fill="#292a2e" opacity="0.1" />
          <g>
            <rect x="139.486" y="493.015" width="80.326" height="23.372" fill="#f4f4f4" />
            <rect x="150.273" y="493.015" width="10.525" height="23.372" fill="#292a2e" opacity="0.05" />
            <rect x="165.784" y="498.095" width="43.764" height="13.85" fill="#fff" />
          </g>
          <g>
            <rect
              x="201.163"
              y="478.788"
              width="81.445"
              height="23.372"
              transform="translate(216.536 -55.814) rotate(23.594)"
              fill="#f4f4f4"
            />
            <rect
              x="201.163"
              y="478.788"
              width="81.445"
              height="23.372"
              transform="translate(216.536 -55.814) rotate(23.594)"
              fill="#292a2e"
              opacity="0.05"
            />
            <rect
              x="258.955"
              y="488.574"
              width="10.672"
              height="23.372"
              transform="translate(222.326 -63.964) rotate(23.594)"
              fill="#fff"
            />
            <rect
              x="212.122"
              y="480.588"
              width="44.373"
              height="13.85"
              transform="translate(214.717 -53.029) rotate(23.594)"
              fill="#fff"
            />
          </g>
          <g>
            <g>
              <rect x="263.837" y="789.091" width="20.186" height="13.481" fill="#292a2e" opacity="0.05" />
              <rect x="57.456" y="789.091" width="20.186" height="13.481" fill="#292a2e" opacity="0.05" />
            </g>
            <rect x="38.953" y="517.483" width="263.574" height="271.152" fill="#f4f4f4" />
            <rect x="38.953" y="517.483" width="263.574" height="271.152" fill="#292a2e" opacity="0.03" />
            <rect x="87.797" y="517.483" width="263.574" height="271.152" fill="#f4f4f4" />
            <g>
              <rect x="312.681" y="789.091" width="20.186" height="13.481" fill="#292a2e" opacity="0.05" />
              <rect x="106.301" y="789.091" width="20.186" height="13.481" fill="#292a2e" opacity="0.05" />
            </g>
            <rect x="97.692" y="530.183" width="243.786" height="52.094" fill="#fff" opacity="0.7" />
            <rect x="97.692" y="595.027" width="243.786" height="52.094" fill="#fff" opacity="0.7" />
            <rect x="97.692" y="659.871" width="243.786" height="52.094" fill="#fff" opacity="0.7" />
            <circle cx="219.585" cy="556.23" r="7.289" fill="#292a2e" opacity="0.05" />
            <circle cx="219.585" cy="621.074" r="7.289" fill="#292a2e" opacity="0.05" />
            <circle cx="219.585" cy="685.919" r="7.289" fill="#292a2e" opacity="0.05" />
            <g>
              <rect x="97.692" y="726.177" width="243.786" height="52.094" fill="#fff" opacity="0.7" />
              <circle cx="219.585" cy="752.224" r="7.289" fill="#292a2e" opacity="0.05" />
            </g>
          </g>
          <g>
            <rect
              x="132.518"
              y="45.492"
              width="155.853"
              height="202.861"
              transform="translate(420.888 293.845) rotate(-180)"
              fill="#f4f4f4"
            />
            <rect x="127.462" y="45.492" width="5.056" height="202.861" fill="#f4f4f4" />
            <rect x="127.462" y="45.492" width="5.056" height="202.861" fill="#292a2e" opacity="0.05" />
            <rect
              x="160.908"
              y="82.446"
              width="99.071"
              height="128.954"
              transform="translate(420.888 293.845) rotate(-180)"
              fill="#292a2e"
              opacity="0.05"
            />
            <rect
              x="160.908"
              y="82.446"
              width="5.163"
              height="128.954"
              transform="translate(326.98 293.845) rotate(-180)"
              fill="#292a2e"
              opacity="0.03"
            />
            <rect
              x="5.056"
              y="298.24"
              width="127.462"
              height="128.633"
              transform="translate(137.573 725.112) rotate(-180)"
              fill="#f4f4f4"
            />
            <rect
              x="28.275"
              y="321.672"
              width="81.024"
              height="81.768"
              transform="translate(137.573 725.112) rotate(-180)"
              fill="#292a2e"
              opacity="0.05"
            />
            <rect y="298.24" width="5.056" height="128.633" fill="#f4f4f4" />
            <rect y="298.24" width="5.056" height="128.633" fill="#292a2e" opacity="0.05" />
            <rect
              x="28.275"
              y="321.672"
              width="5.163"
              height="81.768"
              transform="translate(61.712 725.112) rotate(-180)"
              fill="#292a2e"
              opacity="0.03"
            />
          </g>
          <g>
            <rect id="c_3_c" x="457.061" y="45.009" width="325.24" height="325.24" fill="#f4f4f4" />
            <rect id="c_3_c-2" data-name="c_3_c" x="453.333" y="45.009" width="3.728" height="325.24" fill="#f4f4f4" />
            <rect
              id="c_3_c-3"
              data-name="c_3_c"
              x="453.333"
              y="45.009"
              width="3.728"
              height="325.24"
              fill="#292a2e"
              opacity="0.05"
            />
            <polygon
              id="c_3_c-4"
              data-name="c_3_c"
              points="535.852 269.126 535.852 184.032 605.556 184.032 605.556 233.47 713.527 233.47 713.527 321.005 759.417 321.005 759.417 370.249 713.527 370.249 704.687 370.249 472.706 370.249 472.706 269.126 535.852 269.126"
              fill="#292a2e"
              opacity="0.05"
            />
            <g id="c_3_wh">
              <rect
                id="c_3_wh-2"
                data-name="c_3_wh"
                x="545.849"
                y="193.271"
                width="50.759"
                height="9.239"
                fill="#fffffa"
                opacity="0.34"
              />
              <rect
                id="c_3_wh-3"
                data-name="c_3_wh"
                x="545.849"
                y="212.417"
                width="50.759"
                height="9.239"
                fill="#fffffa"
                opacity="0.34"
              />
              <rect
                id="c_3_wh-4"
                data-name="c_3_wh"
                x="545.849"
                y="231.563"
                width="50.759"
                height="9.239"
                fill="#fffffa"
                opacity="0.34"
              />
            </g>
            <g id="c_3_wh-5" data-name="c_3_wh">
              <rect
                id="c_3_wh-6"
                data-name="c_3_wh"
                x="481.707"
                y="278.094"
                width="9.356"
                height="9.239"
                fill="#fffffa"
                opacity="0.34"
              />
              <rect
                id="c_3_wh-7"
                data-name="c_3_wh"
                x="481.707"
                y="297.24"
                width="9.356"
                height="9.239"
                fill="#fffffa"
                opacity="0.34"
              />
              <rect
                id="c_3_wh-8"
                data-name="c_3_wh"
                x="481.707"
                y="316.385"
                width="9.356"
                height="9.239"
                fill="#fffffa"
                opacity="0.34"
              />
              <rect
                id="c_3_wh-9"
                data-name="c_3_wh"
                x="499.015"
                y="278.094"
                width="9.356"
                height="9.239"
                fill="#fffffa"
                opacity="0.34"
              />
              <rect
                id="c_3_wh-10"
                data-name="c_3_wh"
                x="499.015"
                y="297.24"
                width="9.356"
                height="9.239"
                fill="#fffffa"
                opacity="0.34"
              />
              <rect
                id="c_3_wh-11"
                data-name="c_3_wh"
                x="499.015"
                y="316.385"
                width="9.356"
                height="9.239"
                fill="#fffffa"
                opacity="0.34"
              />
              <rect
                id="c_3_wh-12"
                data-name="c_3_wh"
                x="515.855"
                y="278.094"
                width="9.356"
                height="9.239"
                fill="#fffffa"
                opacity="0.34"
              />
              <rect
                id="c_3_wh-13"
                data-name="c_3_wh"
                x="515.855"
                y="297.24"
                width="9.356"
                height="9.239"
                fill="#fffffa"
                opacity="0.34"
              />
              <rect
                id="c_3_wh-14"
                data-name="c_3_wh"
                x="515.855"
                y="316.385"
                width="9.356"
                height="9.239"
                fill="#fffffa"
                opacity="0.34"
              />
            </g>
            <polygon
              points="457.061 205.804 522.504 205.804 522.504 45.008 527.917 45.008 527.917 205.804 704.687 205.804 704.687 45.008 710.099 45.008 710.099 205.804 782.301 205.804 782.301 211.216 710.099 211.216 710.099 370.249 704.687 370.249 704.687 211.216 527.917 211.216 527.917 370.249 522.504 370.249 522.504 211.216 457.061 211.216 457.061 205.804"
              fill="#fff"
            />
            <rect
              id="c_3_c-5"
              data-name="c_3_c"
              x="444.104"
              y="369.856"
              width="351.153"
              height="10.816"
              fill="#f4f4f4"
            />
            <rect
              id="c_3_c-6"
              data-name="c_3_c"
              x="444.104"
              y="369.856"
              width="351.153"
              height="10.816"
              fill="#292a2e"
              opacity="0.1"
            />
            <rect
              id="c_3_c-7"
              data-name="c_3_c"
              x="439.034"
              y="369.856"
              width="5.07"
              height="10.816"
              fill="#292a2e"
              opacity="0.1"
            />
            <rect
              id="c_3_c-8"
              data-name="c_3_c"
              x="439.034"
              y="369.856"
              width="5.07"
              height="10.816"
              fill="#292a2e"
              opacity="0.1"
            />
          </g>
          <g>
            <g>
              <path
                d="M726.529,425.574c-49.792,0-90.157,13.584-90.157,30.341v36.121H816.687V455.915C816.687,439.158,776.322,425.574,726.529,425.574Z"
                fill="#009ABA"
              />
              <path
                d="M726.529,425.574c-49.792,0-90.157,13.584-90.157,30.341v36.121H816.687V455.915C816.687,439.158,776.322,425.574,726.529,425.574Z"
                fill="#fff"
                opacity="0.49"
              />
              <path
                d="M792.127,455.919v36.115H636.37V455.919c0-15.359,33.9-28.05,77.878-30.056C758.231,427.869,792.127,440.56,792.127,455.919Z"
                fill="#fff"
                opacity="0.49"
              />
              <polygon
                points="816.687 843.01 819.713 843.01 816.687 488.832 813.687 491.858 815.826 739.261 709.013 741.076 706.858 491.832 703.858 491.858 706.014 741.127 641.535 742.223 639.37 491.832 636.37 488.858 639.396 843.01 642.37 842.985 641.56 745.224 706.039 744.128 706.858 843.01 709.858 842.985 709.039 744.077 815.852 742.261 816.687 843.01"
                fill="#292a2e"
              />
            </g>
            <g>
              <path
                d="M544.74,789.984s-5.362,27.793-31.385,29.342-20.38,22.28-20.38,22.28H592.42V791.922Z"
                fill="#009ABA"
              />
              <path
                d="M601.477,706.388s7.457,27.306-15.209,40.183-8.452,28.988-8.452,28.988l89.231-43.9-21.931-44.581Z"
                fill="#009ABA"
              />
              <path
                d="M592.036,724.435,524.8,470.746c-5.1-28.026,2.578-40.174,14.409-51.975,20.786-20.733,106.917-64.861,106.917-64.861l103.33-.282c27.4,0,54.333,27.017,54.333,54.415s-27.853,50.634-55.252,50.634l-127.242,12.7,34.492,232.286Z"
                fill="#262626"
              />
              <polygon
                points="655.786 703.661 642.207 612.213 573.415 654.177 592.036 724.435 655.786 703.661"
                fill="#0c0c0c"
              />
              <path
                d="M671.379,405.247s-43.437,9.68-86.457,52.7c-26.083,26.083-23.944,73.284-20.031,164.067l42.727-63.11,46.864-84.522Z"
                fill="#0c0c0c"
              />
              <path
                d="M821.777,353.6l-70.174-.331-.026.924H730.328S677.1,403.169,634.25,434.032c-31.17,22.448-50.185,43.85-51.83,67.176-4.011,56.861-49.249,299.366-49.249,299.366l68.082,10.309L661,521.071S754.42,478,776.029,463.015c20.348-14.113,34.721-19.569,41.455-34.971C829.113,401.443,821.777,353.6,821.777,353.6Z"
                fill="#262626"
              />
            </g>
            <path
              d="M743.05,371.275l-113.84,1.508,63.859,38.14,53.136-27.439A6.491,6.491,0,0,0,743.05,371.275Z"
              fill="#292a2e"
            />
            <path
              d="M743.05,371.275l-113.84,1.508,63.859,38.14,53.136-27.439A6.491,6.491,0,0,0,743.05,371.275Z"
              fill="#fff"
              opacity="0.2"
            />
            <path
              d="M629.862,167.045l-32.2,104.331-64.495,84.442,37.675,43.248,76.729-85.639a26.527,26.527,0,0,0,8.035-10.6l1.195-2.893L701.121,192.7Z"
              fill="#009ABA"
            />
            <g>
              <g>
                <path
                  d="M679.465,56.3S666.49,46.5,663.276,23.96c-2.49-17.453,13.61-6.146,13.61-6.146s-1.67-12.585,7.5-11.336,14.3,14.469,14.3,14.469"
                  fill="#0c0c0c"
                />
                <path d="M731.776,7.951s45.494,4.877,29.048,66.525l-4.025.27-8.172.548" fill="#0c0c0c" />
                <path
                  id="sk"
                  d="M687.085,138.858c.2-.026,2.42,36.8,45.2,33.593,29.621-2.219,40.182-33.645,40.86-33.645-3.193-.679-7.14-1.709-8.708-2.062a17.28,17.28,0,0,1-13.22-14.532c-.866-5.22.6-31.928.151-37.21L705.906,95.15c.636,11.156,5.082,37.017-10.5,41.594C692.811,137.5,690.017,138.2,687.085,138.858Z"
                  fill="#E98862"
                />
                <path
                  id="sh"
                  d="M705.269,126.175a32.94,32.94,0,0,0,1.368-7.057,75.225,75.225,0,0,0-.3-16.413A49.844,49.844,0,0,0,731.468,91.7c.845,3.118,5.488,16.742,4.2,19.7C733.24,117,721.821,126.175,705.269,126.175Z"
                  fill="#0c0c0c"
                  opacity="1"
                />
                <path
                  d="M714.653,118.886c17.937-1.609,39.406-12.942,39.716-37.291l.279-21.97c.31-24.348-12.228-44.249-35.153-44.541h0c-22.925-.291-40.312,19.229-40.622,43.578l-.123,9.726a73.482,73.482,0,0,0,.728,9.983c1.176,8.75,3,22.053,8.938,31.052C694.023,117.919,703.193,119.913,714.653,118.886Z"
                  fill="#E98862"
                />
                <path
                  d="M706.331,96.63a23.648,23.648,0,0,1-10.771-2.057.579.579,0,0,1,.454-1.065c7.281,3.105,13.892,2.651,19.118-1.314a3.824,3.824,0,0,1,.328-.233.579.579,0,0,1,.576,1c-.042.026-.11.079-.2.151A17.344,17.344,0,0,1,706.331,96.63Z"
                  fill="#0c0c0c"
                  opacity="1"
                />
                <path
                  d="M706.5,102.115a11.752,11.752,0,0,1-2.006-.048.578.578,0,1,1,.122-1.15c4.006.425,5.919-1.41,6-1.489a.578.578,0,0,1,.819.817A7.842,7.842,0,0,1,706.5,102.115Z"
                  fill="#0c0c0c"
                  opacity="1"
                />
                <circle cx="686.444" cy="70.246" r="2.824" fill="#0c0c0c" />
                <circle cx="714.033" cy="68.515" r="2.824" fill="#0c0c0c" />
                <path
                  d="M752.851,89c6.967.089,12.709-7.293,12.8-14.26s-5.511-10.881-12.478-10.969l-3.649,4.622-2.661,20.531Z"
                  fill="#E98862"
                />
                <g>
                  <path
                    d="M745.919,77.8s-2.352-34.453-12.8-36.581c-6.958-1.417-23.831,8.453-39.46,5.472-6.837-1.3-13.328.388-13.988,3.618-.262,1.279-4.521-17.1,6.186-31.044,8.525-11.1,36.422-14.24,49.114-10.6,35.144,10.082,19.636,56.617,19.636,56.617l-1.567,11.878Z"
                    fill="#0c0c0c"
                  />
                  <g opacity="1">
                    <path
                      d="M702.119,88.5a.327.327,0,0,1-.044,0c-2.245-.022-6.009-.311-5.994-1.99.016-1.392,3.976-16.375,4.428-18.079a.572.572,0,0,1,1.106.293c-1.76,6.636-4.38,16.852-4.39,17.8.217.4,2.536.812,4.86.836a.572.572,0,0,1,.034,1.142Z"
                      fill="#0c0c0c"
                    />
                  </g>
                  <path
                    d="M694.46,54.934a13.588,13.588,0,0,0-7.211,0,11.976,11.976,0,0,0-3.279,1.436,14.045,14.045,0,0,0-2.74,2.236.833.833,0,0,0,1.132,1.22l.051-.044a12.214,12.214,0,0,1,2.5-1.789,10.035,10.035,0,0,1,2.837-1.036,11.338,11.338,0,0,1,5.877.329l.079.028a1.252,1.252,0,0,0,.834-2.36Z"
                    fill="#0c0c0c"
                  />
                  <path
                    d="M711.167,56.351a11.333,11.333,0,0,1,5.781-1.109,10.006,10.006,0,0,1,2.949.648,12.279,12.279,0,0,1,2.713,1.44l.054.036a.833.833,0,0,0,.961-1.359,14.046,14.046,0,0,0-3.013-1.851,11.986,11.986,0,0,0-3.442-.986,13.585,13.585,0,0,0-7.146.957,1.252,1.252,0,0,0,1,2.3l.07-.033Z"
                    fill="#0c0c0c"
                  />
                </g>
                <ellipse
                  cx="700.688"
                  cy="17.472"
                  rx="14.04"
                  ry="9.539"
                  transform="translate(540.283 699.776) rotate(-78.199)"
                  fill="#0c0c0c"
                />
              </g>
              <path
                d="M633.926,219.8c1.348,15.832,10.9,114.61,12.2,134.112H821.7c1.009-17.589,5.538-94.5,9.364-128.9,3.652-32.822,8.77-47.758,4.564-57.957-7.418-17.99-31.03-26.023-47.019-28.188-9.764-1.322-24.449-2.269-24.449-2.269s-1.243,25.153-30.891,26.553c-40.36,1.9-37.664-26.553-37.864-26.553-6.539,0-42.128,4.755-51.028,10.555-12.569,8.192-16.284,19.357-16.431,29.614C627.778,188.58,632.4,201.841,633.926,219.8Z"
                fill="#009ABA"
              />
              <path
                d="M642.829,314.986a.5.5,0,0,1-.5-.456l-6.652-76.08a.5.5,0,0,1,.454-.542.493.493,0,0,1,.542.455l6.652,76.08a.5.5,0,0,1-.454.541A.346.346,0,0,1,642.829,314.986Z"
                fill="#0c0c0c"
              />
              <g id="b_4_ha">
                <path
                  d="M655.56,359.178l24.108-19.559-4.057,1.147a5.372,5.372,0,0,1-6.45-3.488,5.175,5.175,0,0,1,3.753-6.507l50.646-12.318,4.358,16.132A26.056,26.056,0,0,1,718.5,362.15l-18.766,14.162a5.3,5.3,0,0,1-6.7-.128,5.174,5.174,0,0,1-1.287-6,.467.467,0,0,1-.212-.132.478.478,0,0,1-.091-.443l-3.457,2.618a5.37,5.37,0,0,1-7.307-.607,5.172,5.172,0,0,1-.019-6.654.46.46,0,0,1-.155-.053l-1.42,1.076a5.3,5.3,0,0,1-6.7-.128,5.18,5.18,0,0,1-.574-7.159.466.466,0,0,1-.05-.093l-10.04,8.145a4.88,4.88,0,1,1-6.149-7.58Z"
                  fill="#E98862"
                />
                <path
                  id="b_4_ha_sh"
                  d="M672.362,358.9a.474.474,0,0,0,.146-.083l9.66-8.025a.486.486,0,1,0-.622-.747l-9.659,8.024a.486.486,0,0,0,.475.831Z"
                  fill="#0a0a0a"
                  opacity="0.2"
                />
                <path
                  id="b_4_ha_sh-2"
                  data-name="b_4_ha_sh"
                  d="M680.875,364.961a.475.475,0,0,0,.143-.081l7.641-6.248a.486.486,0,0,0-.615-.753l-7.641,6.248a.486.486,0,0,0,.472.834Z"
                  fill="#0a0a0a"
                  opacity="0.2"
                />
                <path
                  id="b_4_ha_sh-3"
                  data-name="b_4_ha_sh"
                  d="M692.059,370.2a.506.506,0,0,0,.153-.089l3.539-3.035a.485.485,0,1,0-.632-.737l-3.54,3.035a.486.486,0,0,0,.48.826Z"
                  fill="#0a0a0a"
                  opacity="0.2"
                />
              </g>
              <path
                d="M868.632,311.271l-.185-.821L836.4,168.708,773,183.04l25.013,110.639L697.815,318.3l12.331,56.538L843.672,349.37c.3-.059.745-.149,1.049-.218A31.675,31.675,0,0,0,868.632,311.271Z"
                fill="#009ABA"
              />
              <path
                d="M697.325,318.407a.5.5,0,0,1,.37-.588l99.752-24.5-16.219-71.636a.5.5,0,1,1,.974-.221l16.328,72.115a.5.5,0,0,1-.368.6l-99.759,24.5s.668,2.916.857,3.9a.486.486,0,0,1-.966.112C698.064,321.61,697.325,318.407,697.325,318.407Z"
                fill="#0c0c0c"
              />
              <g>
                <path
                  d="M701.235,397.357,662.71,278.934a10.364,10.364,0,0,0-9.857-7.159H495.9a10.365,10.365,0,0,0-9.857,13.572L524.569,403.77a10.366,10.366,0,0,0,9.857,7.159H691.378A10.366,10.366,0,0,0,701.235,397.357Z"
                  fill="#292a2e"
                />
                <path
                  d="M701.235,397.357,662.71,278.934a10.364,10.364,0,0,0-9.857-7.159H495.9a10.365,10.365,0,0,0-9.857,13.572L524.569,403.77a10.366,10.366,0,0,0,9.857,7.159H691.378A10.366,10.366,0,0,0,701.235,397.357Z"
                  fill="#fff"
                  opacity="0.2"
                />
                <circle cx="589.118" cy="341.352" r="16.461" fill="#fff" />
              </g>
            </g>
          </g>
          <g>
            <rect x="96.512" y="12.514" width="363.775" height="430.432" rx="26.131" fill="#292a2e" />
            <g>
              <rect x="108.026" y="1" width="363.775" height="430.432" rx="26.131" fill="#fff" />
              <path
                d="M445.67,432.432H134.157A27.161,27.161,0,0,1,107.026,405.3V27.131A27.161,27.161,0,0,1,134.157,0H445.67A27.161,27.161,0,0,1,472.8,27.131V405.3A27.161,27.161,0,0,1,445.67,432.432ZM134.157,2a25.159,25.159,0,0,0-25.131,25.131V405.3a25.159,25.159,0,0,0,25.131,25.131H445.67A25.158,25.158,0,0,0,470.8,405.3V27.131A25.158,25.158,0,0,0,445.67,2Z"
                fill="#292a2e"
              />
            </g>
            <circle cx="103.83" cy="420.667" r="64.877" fill="#292a2e" />
            <g>
              <path
                d="M90.362,412.2a3.221,3.221,0,0,1-3.221-3.22V393.389c0-8.621,7.487-15.636,16.689-15.636s16.689,7.015,16.689,15.636V407.91a3.221,3.221,0,1,1-6.441,0V393.389c0-5.07-4.6-9.195-10.248-9.195s-10.248,4.125-10.248,9.195v15.593A3.22,3.22,0,0,1,90.362,412.2Z"
                fill="#fff"
              />
              <rect x="78.945" y="406.285" width="49.77" height="47.384" rx="4.339" fill="#fff" />
              <path
                d="M99.739,426.145a4.094,4.094,0,0,0,2.3,3.682v6.286a1.786,1.786,0,0,0,3.572,0v-6.286a4.091,4.091,0,1,0-5.877-3.682Z"
                fill="#292a2e"
              />
            </g>
            <g>
              <g>
                <rect x="150.247" y="215.773" width="279.333" height="58.27" rx="11.113" fill="#fff" />
                <path
                  d="M418.466,275.042H161.36a12.127,12.127,0,0,1-12.113-12.113V226.886a12.128,12.128,0,0,1,12.113-12.114H418.466a12.128,12.128,0,0,1,12.114,12.114v36.043A12.127,12.127,0,0,1,418.466,275.042ZM161.36,216.772a10.124,10.124,0,0,0-10.113,10.114v36.043a10.124,10.124,0,0,0,10.113,10.113H418.466a10.125,10.125,0,0,0,10.114-10.113V226.886a10.125,10.125,0,0,0-10.114-10.114Z"
                  fill="#292a2e"
                />
              </g>
              <g>
                <rect x="150.247" y="299.047" width="279.333" height="58.27" rx="11.113" fill="#fff" />
                <path
                  d="M418.466,358.316H161.36A12.127,12.127,0,0,1,149.247,346.2V310.16a12.127,12.127,0,0,1,12.113-12.113H418.466A12.127,12.127,0,0,1,430.58,310.16V346.2A12.127,12.127,0,0,1,418.466,358.316ZM161.36,300.047a10.124,10.124,0,0,0-10.113,10.113V346.2a10.124,10.124,0,0,0,10.113,10.113H418.466A10.124,10.124,0,0,0,428.58,346.2V310.16a10.124,10.124,0,0,0-10.114-10.113Z"
                  fill="#292a2e"
                />
              </g>
              <g>
                <circle cx="289.913" cy="112.736" r="59.694" fill="#fff" />
                <path
                  d="M289.913,173.43a60.694,60.694,0,1,1,60.694-60.694A60.762,60.762,0,0,1,289.913,173.43Zm0-119.388a58.694,58.694,0,1,0,58.694,58.694A58.76,58.76,0,0,0,289.913,54.042Z"
                  fill="#292a2e"
                />
              </g>
              <g>
                <path
                  d="M348.281,112.736a58.154,58.154,0,0,1-13.83,37.719,58.669,58.669,0,0,0-89.076.016,58.371,58.371,0,1,1,102.906-37.735Z"
                  fill="#009ABA"
                  opacity="0.5"
                />
                <path
                  d="M334.451,150.455a58.371,58.371,0,0,1-89.076.016,58.669,58.669,0,0,1,89.076-.016Z"
                  fill="#fff"
                />
                <circle cx="289.914" cy="95.5" r="23.593" fill="#fff" />
              </g>
              <g opacity="0.4">
                <circle cx="171.889" cy="328.182" r="7.096" fill="#292a2e" />
                <circle cx="194.086" cy="328.182" r="7.096" fill="#292a2e" />
                <circle cx="216.283" cy="328.182" r="7.096" fill="#292a2e" />
                <circle cx="238.48" cy="328.182" r="7.096" fill="#292a2e" />
                <circle cx="260.676" cy="328.182" r="7.096" fill="#292a2e" />
                <circle cx="282.873" cy="328.182" r="7.096" fill="#292a2e" />
                <circle cx="305.07" cy="328.182" r="7.096" fill="#292a2e" />
              </g>
              <g opacity="0.3">
                <path d="M178.927,244.48v2.4h-9.113v-2.4Z" />
                <path d="M190.252,244.48v2.4h-9.113v-2.4Z" />
                <path d="M201.576,244.48v2.4h-9.113v-2.4Z" />
                <path d="M212.9,244.48v2.4h-9.113v-2.4Z" />
                <path d="M224.226,244.48v2.4h-9.114v-2.4Z" />
                <path d="M244.663,258.021A13.442,13.442,0,0,1,238.1,259.5c-6.051,0-11.18-4.428-11.18-11.512,0-7.6,5.277-14.168,13.467-14.168,6.42,0,10.737,4.5,10.737,10.663,0,5.535-3.1,8.781-6.568,8.781-1.475,0-2.84-1-2.73-3.246h-.148a5.8,5.8,0,0,1-5.2,3.246c-2.14,0-3.985-1.734-3.985-4.648a8.714,8.714,0,0,1,8.745-8.745,9.725,9.725,0,0,1,3.948.775l-1.255,6.678c-.553,2.8-.11,4.1,1.107,4.133,1.882.036,3.985-2.473,3.985-6.752,0-5.35-3.21-9.187-8.929-9.187-6.014,0-11.069,4.759-11.069,12.249,0,6.162,4.022,9.962,9.483,9.962a11.515,11.515,0,0,0,5.571-1.291Zm-2.029-15.939a6.368,6.368,0,0,0-1.845-.258c-3.247,0-5.866,3.062-5.866,6.641,0,1.623.812,2.8,2.435,2.8,2.14,0,4.095-2.73,4.5-5.018Z" />
                <path d="M262.737,244.48v2.4h-9.113v-2.4Z" />
                <path d="M274.062,244.48v2.4h-9.114v-2.4Z" />
                <path d="M285.386,244.48v2.4h-9.113v-2.4Z" />
              </g>
            </g>
          </g>
        </g>
      </svg>
    </Box>
  );
}
